import styled from 'styled-components'
import { Text } from '@pinchenterprisesnpm/friday-ui'

// TODO: Remove this styled component when Text component will be exposed with fontStyle property
export const StyledText = styled(Text)`
  font-style: italic;
`

export const TimePickerStyle = styled.div<{ error: boolean }>`
  width: 100%;
  & .react-time-picker__wrapper,
  & .react-time-picker {
    height: 100%;
    width: 100%;
  }
  & .react-time-picker *,
  & .react-time-picker svg {
    color: ${(props) => props.theme.palette.dark};
    border-color: ${(props) =>
      props.error ? props.theme.palette.danger : props.theme.palette.light};
    stroke: ${(props) => props.theme.palette.dark};
    font-weight: ${(props) => props.theme.font.weights.regular};
  }
`
